import React from 'react'

const InfoNotesExtra = () => {
  return (
    <div className='content-text'>
        The “Notes” and “Extra Options” sections allow you to include any necessary notes and provide additional information using a simple “yes” or “no” format. 
        <br /><br />
        <span>Additional Charges - </span>Include these charges in the building cost by either adding or updating the amount in the provided additional charges options.
    </div>
  )
}

export default InfoNotesExtra